import {
    BoxGeometry,
    Mesh,
    MeshLambertMaterial,
    Scene,
} from 'three';
import * as THREE from "three";
import TWEEN from "three/addons/libs/tween.module.js";

class CustomEnvironment extends Scene {
    constructor(distance,tableHeight, addReflection = false) {
        super();

        this.background =new THREE.Color( '#ececec' );
        // Initialize lights with non-zero intensity for visibility
        this.ambientLight = new THREE.AmbientLight('#ffffff', 0.2);
         this.add(this.ambientLight);

        this.light = new THREE.DirectionalLight(0xdfebff, 0.2);
        this.light.position.set(-75, 200, 120);
        this.light.shadow.bias = -0.002;
        this.light.castShadow = true;
        this.add(this.light);

        // Shadow properties
        this.light.shadow.mapSize.width = 2048;
        this.light.shadow.mapSize.height = 2048;
        this.light.shadow.camera.near = 0.5;
        this.light.shadow.camera.far = distance;
        let di = 500;
        this.light.shadow.camera.left = -di;
        this.light.shadow.camera.right = di;
        this.light.shadow.camera.top = di;
        this.light.shadow.camera.bottom = -di;


        if(addReflection) {
            //Additional light setup for reflectionmaps
            const geometry = new BoxGeometry();
            const material3 = new MeshLambertMaterial({color: "#0000ff", emissive: "#ffffff", emissiveIntensity: 1.5});

            // backlights
            const light3 = new Mesh(geometry, material3);
            light3.position.set(0, -1, 5);
            light3.scale.set(8, 6, 0.1);
            this.add(light3);

            // air light
            const light4 = new Mesh(geometry, material3);
            light4.position.set(0, 6, -6);
            light4.scale.set(4, 1.5, 0.1);
            this.add(light4);
            light4.rotateX(Math.PI /4);
        }
    }

    lightOn(time = 300) {
        //new TWEEN.Tween(this.ambientLight).to({intensity: 1}, time).start();
        new TWEEN.Tween(this.light).to({intensity: 0.2}, time).start();
    }
}

export { CustomEnvironment };
